import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
const routes = [
  {
    name: "home",
    path: "/",
    component: () => import("./view/home"),
  },
  {
    name: "product",
    path: "/product",
    component: () => import("./view/product"),
  },
];

// add route path
routes.forEach((route) => {
  route.path = route.path || "/" + (route.name || "");
});

const router = new Router({
  mode: 'history',
  routes: routes
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export { router };
